(() => {
  const init = (section) => {
    const track = section.querySelector('[data-lamp-track]');
    const next = section.querySelector('[data-lamp-next]');
    if (!track || !next) return;

    const update = () => {
      next.disabled = track.scrollWidth - track.clientWidth - track.scrollLeft < 3;
    };
    next.addEventListener('click', () => {
      const card = track.querySelector('.home-lamp-curation__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const max = track.scrollWidth - track.clientWidth;
      track.scrollTo({ left: Math.min(max, track.scrollLeft + card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  document.querySelectorAll('[data-lamp-curation]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-lamp-curation]').forEach(init);
  });
})();
